/**
 * Small fixed "Demo — read-only" affordance shown only inside the marketing
 * live embed (P6-C). Signals that the surface is live but look-only, so a
 * visitor who clicks a disabled control understands why. Purely cosmetic —
 * the server guards are what actually enforce read-only.
 */
export function DemoReadOnlyBadge() {
  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        bottom: 12,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2147483647,
        display: "flex",
        alignItems: "center",
        gap: 7,
        padding: "6px 13px",
        borderRadius: 9999,
        background: "rgba(15,23,42,0.86)",
        color: "#fff",
        font: "600 12px/1 system-ui, -apple-system, sans-serif",
        letterSpacing: 0.2,
        boxShadow: "0 6px 20px -6px rgba(2,6,23,0.6)",
        backdropFilter: "blur(6px)",
        pointerEvents: "none",
        userSelect: "none",
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: 9999,
          background: "#34d399",
          boxShadow: "0 0 0 3px rgba(52,211,153,0.25)",
        }}
      />
      Live demo — read-only
    </div>
  );
}
